<section
  class="footer-container"
  fxLayout="column"
  fxLayoutAlign="space-between center"
  fxLayoutGap="1rem">
  <div class="footer-links" fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <div class="footer-link">
        <mat-icon color="accent">chevron_right</mat-icon>
        <a
          type="button"
          class="footer-link-line"
          href="https://www.ganahllumber.com/"
          target="_blank"
          >Home</a
        >
      </div>

      <div class="footer-link">
        <mat-icon color="accent">chevron_right</mat-icon>
        <a
          type="button"
          class="footer-link-line"
          href="https://www.ganahllumber.com/privacy/"
          target="_blank"
          >Privacy policy</a
        >
      </div>

      <div class="footer-link">
        <mat-icon color="accent">chevron_right</mat-icon>
        <a class="footer-link-line" routerLink="/secure/whats-new"
          >What's new</a
        >
      </div>

      <div class="footer-link">
        <mat-icon color="accent">chevron_right</mat-icon>
        <a
          type="button"
          class="footer-link-line"
          href="https://www.ganahllumber.com/links/"
          target="_blank"
          >Helpful resources</a
        >
      </div>
    </div>

    <div>
      <div class="footer-link">
        <mat-icon color="accent">chevron_right</mat-icon>
        <a
          type="button"
          class="footer-link-line"
          href="https://www.ganahllumber.com/commercial-credit/"
          target="_blank"
          >Commercial credit</a
        >
      </div>

      <div class="footer-link">
        <mat-icon color="accent">chevron_right</mat-icon>
        <a
          type="button"
          class="footer-link-line"
          href="https://www.ganahllumber.com/careers/"
          target="_blank"
          >Careers</a
        >
      </div>

      <div class="footer-link">
        <mat-icon color="accent">chevron_right</mat-icon>
        <a
          type="button"
          class="footer-link-line"
          href="https://www.ganahllumber.com/about/contact-us"
          target="_blank"
          >Contact us</a
        >
      </div>

      <div class="footer-link">
        <mat-icon color="accent">chevron_right</mat-icon>
        <a
          type="button"
          class="footer-link-line"
          href="https://www.ganahllumber.com/Locations/"
          target="_blank"
          >Locate a store</a
        >
      </div>
    </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="center center">
    <p class="footer-copyright">
      &copy; {{ currentYear }} <span>Ganahl Lumber Company</span>
    </p>
  </div>
</section>
